import type { ReactNode } from 'react';

import { Link } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';

import { NessoLogo } from '@nesso/ui/icons/nesso-logo';

type Props = {
    clientName: string;
    children?: ReactNode;
};

export function RecordingHeader({ clientName, children }: Props) {
    return (
        <div className="w-full h-16 p-5 shrink-0  flex justify-between items-center overflow-hidden">
            <div className="flex items-center gap-2">
                <Link to="/dashboard" aria-label="Go to dashboard">
                    <NessoLogo />
                </Link>
                <ChevronRight className="size-4" />
                <span title={clientName} className="text-sm truncate max-w-50">
                    {clientName}
                </span>
            </div>
            {children}
        </div>
    );
}
